export const Roles = {
  ADMIN: 'admin',
  MANAGER: 'manager',
  LEAD: 'lead',
  CONSULTANT: 'consultant',
};
